module.exports = __webpack_public_path__ + "static/media/oocvol_no_zoom.bc501179.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/oocvol_no_zoom.png
// module id = 97
// module chunks = 0